module.exports = __webpack_public_path__ + "static/assets/1c7601e2ecb50ff82bfe0ad384194e38.svg";